import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

export const Field = ({ label, hint, children, className, required }) => (
  <div className={cn("space-y-1.5", className)}>
    {label && (
      <Label className="text-xs font-semibold uppercase tracking-wider text-zinc-600">
        {label} {required && <span className="text-brand">*</span>}
      </Label>
    )}
    {children}
    {hint && <p className="text-[11px] text-zinc-500">{hint}</p>}
  </div>
);

export const inputCls = "h-12 w-full rounded-md border border-zinc-300 bg-white px-3 text-sm focus:border-ink focus:outline-none focus:ring-1 focus:ring-ink";

export const DateField = ({ value, onChange, testid, label = "Tanggal", className }) => (
  <Field label={label} className={className} required>
    <input type="date" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={inputCls} />
  </Field>
);
